"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _guid = _interopRequireDefault(require("../guid"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const withUniqueIdProps = WrappedComponent => {
  let WithUniqueIdProps = /*#__PURE__*/function (_React$Component) {
    _inherits(WithUniqueIdProps, _React$Component);

    var _super = _createSuper(WithUniqueIdProps);

    function WithUniqueIdProps(...args) {
      var _this;

      _classCallCheck(this, WithUniqueIdProps);

      _this = _super.call(this, ...args);

      _defineProperty(_assertThisInitialized(_this), "id", (0, _guid.default)());

      _defineProperty(_assertThisInitialized(_this), "name", (0, _guid.default)());

      return _this;
    }

    _createClass(WithUniqueIdProps, [{
      key: "render",
      value: function render() {
        const {
          forwardedRef,
          id,
          ...props
        } = this.props;
        return /*#__PURE__*/_react.default.createElement(WrappedComponent, _extends({
          id: id || this.id,
          name: this.name,
          ref: forwardedRef
        }, props));
      }
    }]);

    return WithUniqueIdProps;
  }(_react.default.Component);

  _defineProperty(WithUniqueIdProps, "propTypes", {
    forwardedRef: _propTypes.default.object,
    id: _propTypes.default.string
  });

  const Component = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
    return /*#__PURE__*/_react.default.createElement(WithUniqueIdProps, _extends({}, props, {
      forwardedRef: ref
    }));
  });

  const displayName = WrappedComponent.displayName || WrappedComponent.name || "WithUniqueIdProps(Unknown)";
  Component.displayName = displayName.replace(/^Base/, "");
  return Component;
};

var _default = withUniqueIdProps;
exports.default = _default;